import {useSelector} from 'react-redux'

const useOnboarding = ()=>{
	//get relevant onboarding data objects
	const firstLogin = useSelector(state=>state.onboarding.firstLogin)
	const accountType = useSelector(state=>state.users.current_user.account_type)
	const genericProgramAutomation = useSelector(
		state=>state.onboarding.genericProgramAutomation
	)
	//assemble array of onboarding steps
	const onboardingSteps = []
	if(Boolean(firstLogin.show)){
		//add type for dynamic component rendering
		onboardingSteps.push({
			type:'first_login',
			...firstLogin
		})
	}
	if(
		Boolean(genericProgramAutomation.show) && 
		genericProgramAutomation.categories.length > 0 &&
		//only clients should see this
		accountType === 'client'
	){
		//add type for dynamic component rendering
		onboardingSteps.push({
			type:'generic_program_automation',
			...genericProgramAutomation
		})
	}
	return onboardingSteps
}

export default useOnboarding